import { HStack, Spacer, XButton, XDiv, XText, XTooltip } from "IZOX/_X";
import { ColorX, FIconX, ZMath } from "IZOX/STATIC";
import { BiRename } from "react-icons/bi";
import { FaDownload, FaEdit, FaFolder, FaTrash } from "react-icons/fa";
import { FaTrashArrowUp } from "react-icons/fa6";
import BAvatar from "../../BAvatar/BAvatar";
import QFileStatusUtils from "./QFileStatusUtils";
import { HiDocumentReport } from "react-icons/hi";

/**
 * @type {import("IZOX/BLOCKS/Libs/QTable/QTable").qtableschema[]}
 */
const qfileexplorer = [
  {
    label: "",
    name: "type",
    width: 50,
    Cell: (doc, field, addOns) => {
      if(field === "folder"){
        return (
          <XTooltip tooltip={{EN: "Folder", TC: "資料夾"}}>
            <FaFolder color={ColorX.CSS("cmBlue")} size={20}/>
          </XTooltip>
        );
      }else{
        return (
          <XTooltip tooltip={{EN: "File", TC: "檔案"}}>
            {FIconX.Get(doc?.asset?.type, 20, {
              color: ColorX.DayNight({day: "pureDark", night: "dmWhite"})
            })}
          </XTooltip>
        );
      }
    }
  },
  {
    label: {
      EN: "Name",
      TC: "名稱",
    },
    name: "name",
    Cell: (doc, field, addOns, {
      isHover, isSelected
    }) => {
      if(doc.type === "folder"){
        return (
          <HStack pL={10} pR={20} HAlign="[">
            <XButton onPress={() => addOns?.selectFolder(doc._id)} pV={2}
              opacity={doc.active ? 1 : 0.4}>
              <XText color={ColorX.CSS("cmBlue")} bold noWrap 
                ellipsisMode="ellipsis">{field}</XText>
            </XButton>
            <Spacer/>
            {isHover &&
              <HStack spacing={5} fitWidthToContent flexShrink={0}>
                {addOns?.canEdit &&
                  <XButton tooltip={{
                    EN: "Rename", TC: "重新命名"
                  }} onPress={() => addOns?.renameFolder(doc)} p={5}
                  disabled={!addOns?.canEdit}>
                    <BiRename color={ColorX.CSS("cmBlue")} size={15}/>
                  </XButton>}
                {addOns?.canEdit && doc.active &&
                  <XButton tooltip={{
                    EN: "Delete", TC: "刪除"
                  }} onPress={() => addOns?.deleteFolder(doc)} p={5}
                  disabled={!addOns?.canEdit}>
                    <FaTrash color={ColorX.CSS("red")} size={15}/>
                  </XButton>}
                {addOns?.canEdit && !doc.active && 
                  <XButton tooltip={{
                    EN: "Restore", TC: "還原"
                  }} onPress={() => addOns?.restoreFolder(doc)} p={5}
                  disabled={!addOns?.canEdit}>
                    <FaTrashArrowUp color={ColorX.CSS("green")} size={15}/>
                  </XButton>}
              </HStack>
            }
          </HStack>
        );
      }else{
        return (
          <HStack pH={20} HAlign="[">
            <XText opacity={doc.active ? 1 : 0.4} noWrap 
              color={ColorX.DayNight({day: "pureDark", night: "dmWhite"})}
              ellipsisMode="ellipsis">{field}</XText>
            <Spacer/>
            {isHover &&
              <HStack spacing={5} fitWidthToContent flexShrink={0}>
                {addOns?.canEdit
                  && <XButton tooltip={{
                    EN: "Edit", TC: "編輯"
                  }} onPress={() => addOns?.editFile(doc)} p={5}
                  disabled={!addOns?.canEdit}>
                    <FaEdit color={ColorX.CSS("cmBlue")} size={15}/>
                  </XButton>}
                {addOns?.canEdit
                  && <XButton tooltip={{
                  EN: "Rename", TC: "重新命名"
                }} onPress={() => addOns?.renameFile(doc)} p={5}
                disabled={!addOns?.canEdit}>
                  <BiRename color={ColorX.CSS("cmBlue")} size={15}/>
                </XButton>}
                <XButton tooltip={{
                  EN: "Download", TC: "下載"
                }} onPress={() => addOns?.downloadFile(doc)} p={5}>
                  <FaDownload color={ColorX.CSS("cmBlue")} size={15}/>
                </XButton>
                {doc.active && doc.issueSummary
                  && <XButton tooltip={{
                    EN: "Issue Summary", TC: "問題摘要"
                  }} onPress={() => addOns?.issueSummary(doc)} p={5}>
                    <HiDocumentReport color={ColorX.CSS("cmBlue")} size={15}/>
                  </XButton>}
                {addOns?.canEdit && doc.active &&
                  <XButton tooltip={{
                    EN: "Delete", TC: "刪除"
                  }} onPress={() => addOns?.deleteFile(doc)} p={5}
                  disabled={!addOns?.canEdit}>
                    <FaTrash color={ColorX.CSS("red")} size={15}/>
                  </XButton>}
                {addOns?.canEdit && !doc.active &&
                  <XButton tooltip={{
                    EN: "Restore", TC: "還原"
                  }} onPress={() => addOns?.restoreFile(doc)} p={5}
                  disabled={!addOns?.canEdit}>
                    <FaTrashArrowUp color={ColorX.CSS("green")} size={15}/>
                  </XButton>}
              </HStack>}
          </HStack>
        );
      }
    }, 
    filterFormat: "text",
    textAlign: "["
  },
  {
    label: {
      EN: "System",
      TC: "系統"
    },
    name: "system",
    format: "select",
    filterFormat: "select",
    selectOptions: "gammonsys",
    selectValAccessor: "val",
    selectCapAccessor: "name"
  },
  {
    label: {
      EN: "Status",
      TC: "狀態"
    },
    name: "status",
    format: "select",
    filterFormat: "select",
    selectOptions: QFileStatusUtils.Status,
    selectBgColorAccessor: "bgColor",
    selectColorAccessor: "color",
    displayType: "bullet",
    width: 150,
    Cell: (doc, field, addOns) => {
      if(doc.type === "file"){
        return null;
      }else{
        return <XDiv/>;
      }
    }
  },
  {
    label: {
      EN: "File Size",
      TC: "檔案大小",
    },
    name: "asset.size",
    width: 150,
    Cell: (doc, field) => {
      return field ? ZMath.FileSizeUnit(field).join(" ") : "";
    }
  },
  {
    label: {
      EN: "Created By",
      TC: "建立者",
    },
    name: "createdBy",
    Cell: (doc, field, addOns) => {
      return (
        <BAvatar user={field} size={14}/>
      );
    },
    sortComparer: (doc, field, addOns) => field?.userDisplayName,
    filterFormat: "text",
    width: 200
  },
  {
    label: {
      EN: "Created At",
      TC: "建立時間",
    },
    name: "createdAt",
    format: "datetime",
    filterFormat: "date",
    width: 200
  }
];

export default qfileexplorer;